import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { InputEl } from 'common/components/input';
import { ButtonTheme } from 'common/components/button/constants';
import { Necessary, ValidationStatus } from '../input/types';
import overrides from './override.styl?inline';
export function template() {
  const {
    value,
    errors
  } = this.state;
  const disabled = this.attr("disabled");
  const readOnly = this.attr("readonly");
  const theme = this.attr("theme");
  const busy = this.attr("busy");
  const maxLength = this.attr("maxlength");
  const minLength = this.attr("min");
  const inputAttrs = Object.assign(Object.assign(Object.assign({
    placeholder: this.attr("placeholder"),
    necessary: Necessary.Required
  }, maxLength ? {
    maxlength: maxLength
  } : {}), minLength ? {
    min: minLength.toString()
  } : {}), {
    'validation-status': errors.length > 0 ? ValidationStatus.Invalid : ValidationStatus.Default,
    'error-message': this.helpers.getErrorMessage()
  });
  const buttonAttrs = {
    disabled: disabled || !this.helpers.isValid(),
    theme: ButtonTheme.Primary
  };

  if (disabled || busy) {
    inputAttrs.disabled = true;
  }

  if (readOnly) {
    inputAttrs.readonly = true;
  }

  if (theme) {
    buttonAttrs.theme = theme;
  }

  if (this.attr("icon") || this.attr("busy")) {
    buttonAttrs.icon = this.attr("busy") ? "spinner" : this.attr("icon");
  }

  return jsx("div", {
    sel: '.mp-input-group-container'
  }, jsx(InputEl, {
    sel: '.mp-input-group-input',
    attrs: Object.assign(Object.assign({}, inputAttrs), {
      'style-override': overrides
    }),
    props: {
      value
    },
    on: {
      input: this.helpers.setValue,
      keyup: this.helpers.submitIfEnter,
      blur: this.helpers.checkErrors,
      focus: this.helpers.handleFocus
    }
  }), jsx(ButtonEl, {
    sel: '.mp-button.mp-input-group-btn',
    attrs: buttonAttrs,
    on: {
      click: this.helpers.submit
    }
  }, this.attr("busy") ? null : this.attr("label")));
}